export default __webpack_public_path__ + "static/media/logo2.f9740f65.png";